export const ENV_VARS = {
	APP_TITLE: process.env.VITE_APP_TITLE,
	API_URL: process.env.VITE_API_URL || "",
	ESTRACK_DOMAIN: process.env.VITE_ESTRACK_DOMAIN || "",
	HEAPER_APP_ID: process.env.VITE_HEAPER_APP_ID || "",
	INTERCOM_ID: process.env.VITE_INTERCOM_ID || "",
	LAUNCH_DARKLY_CLIENT_ID: process.env.VITE_LAUNCH_DARKLY_CLIENT_ID || "",
	STRIPE_PUBLISHABLE_KEY: process.env.VITE_STRIPE_PUBLISHABLE_KEY || "",
} as const;
